import LineChart from './LineChart'
import { distribute, inputFromRound } from '../../lib/scoring'
import type { Player, RoundInput } from '../../lib/scoring'
import type { BidType, TrumpSuit } from '../../../../shared/types'

const PALETTE = ['#f5c451', '#7ed6b8', '#ff9aa2', '#a9c4ff', '#e2b6ff', '#ffd9a0']

export interface GameCurveRound {
  roundNumber: number
  bidderId: number
  partnerId?: number
  bidType: BidType
  trumpSuit?: TrumpSuit
  tricksTaken: number
  won?: boolean
}

export interface GameCurveGame {
  players: Player[]
  rounds: GameCurveRound[]
}

interface GameCurveProps {
  game: GameCurveGame
  ariaLabel: string
  height?: number
}

/** Pointkurve for et spil: kumulerede point pr. spiller, runde for runde. Genbruges på spilsiden. */
function GameCurve({ game, ariaLabel, height }: GameCurveProps) {
  const series = game.players.map((player, index) => {
    const points = [0]
    game.rounds.forEach((round, i) => {
      const input: RoundInput = inputFromRound(round)
      const dist = distribute(game.players, i, input)
      points.push(points[points.length - 1] + (dist[player.userId] ?? 0))
    })
    return {
      key: player.userId,
      label: player.name,
      color: PALETTE[index % PALETTE.length],
      points
    }
  })

  return <LineChart series={series} ariaLabel={ariaLabel} height={height} />
}

export default GameCurve
